module.exports = __webpack_public_path__ + "img/user-attribute-green.25dd5489.svg";